var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.54545H15.3333V0H14V2.54545H6V0H4.66667V2.54545H1C0.734878 2.54579 0.480704 2.66083 0.293234 2.86535C0.105765 3.06986 0.000308769 3.34714 0 3.63636V18.9091C0.000308769 19.1983 0.105765 19.4756 0.293234 19.6801C0.480704 19.8846 0.734878 19.9997 1 20H19C19.2651 19.9997 19.5193 19.8846 19.7068 19.6801C19.8942 19.4756 19.9997 19.1983 20 18.9091V3.63636C19.9997 3.34714 19.8942 3.06986 19.7068 2.86535C19.5193 2.66083 19.2651 2.54579 19 2.54545ZM18.6667 18.5455H1.33333V4H4.66667V5.81818H6V4H14V5.81818H15.3333V4H18.6667V18.5455Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47489 12.426L7.20884 9.95398L6.26605 10.9825L9.47489 14.483L14.7088 8.77325L13.766 7.74475L9.47489 12.426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisit);
export default __webpack_public_path__ + "static/media/icon-visit.99707823ebc070ab1b380d0bacef51e7.svg";
export { ForwardRef as ReactComponent };